// extracted by mini-css-extract-plugin
module.exports = {"HeaderCloseButton":"OTtEGWmQB1GtfqDApVFf1g=="};